import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import RefreshIcon from "@mui/icons-material/RefreshOutlined";
import RestartAlt from "@mui/icons-material/RestartAltOutlined";
import searchFill from "@iconify/icons-eva/search-fill";
import trash2Fill from "@iconify/icons-eva/trash-2-fill";
import roundFilterList from "@iconify/icons-ic/round-filter-list";
import DownloadIcon from "@mui/icons-material/DownloadOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
// material
import { styled } from "@mui/material/styles";
import { Box, Toolbar, Tooltip, IconButton, Typography, OutlinedInput, InputAdornment, Button, Stack } from "@mui/material";

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  // height: 96,
  minHeight: 96,
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(3, 1, 3, 3),
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": { width: 320, boxShadow: theme.customShadows.z8 },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

// ----------------------------------------------------------------------

ListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
};

export default function ListToolbar({ numSelected, filterName, onFilterName, children, onRefresh, onReset, onSearch, onExport,onUpdate,onLotteryCodes }) {
  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: "primary.main",
          bgcolor: "primary.lighter",
        }),
      }}
    >
      {children ? (
        children
      ) : (
        <Stack direction="row">
          {numSelected > 0 ? (
            <Typography component="div" variant="subtitle1">
              选中{numSelected}条
            </Typography>
          ) : (
            <SearchStyle
              size="small"
              value={filterName}
              onChange={onFilterName}
              placeholder="搜索..."
              startAdornment={
                <InputAdornment position="start">
                  <Box component={Icon} icon={searchFill} sx={{ color: "text.disabled" }} />
                </InputAdornment>
              }
            />
          )}
        </Stack>
      )}

      <Stack direction="row" alignItems="center" spacing={1}>
        {!!onSearch && (
          <Button variant="contained" size="small" startIcon={<SearchOutlinedIcon />} onClick={onSearch} sx={{ whiteSpace: "nowrap" }}>
            查询
          </Button>
        )}

        {!!onReset && (
          <Button variant="outlined" size="small" startIcon={<RestartAlt />} onClick={onReset} sx={{ whiteSpace: "nowrap" }}>
            重置
          </Button>
        )}

        {!!onExport && (
          <Button variant="outlined" size="small" startIcon={<DownloadIcon />} onClick={onExport} sx={{ whiteSpace: "nowrap" }}>
            导出
          </Button>
        )}

        {!!onUpdate && (
          <Button variant="outlined" size="small" startIcon={<RefreshIcon />} onClick={onUpdate} sx={{ whiteSpace: "nowrap" }}>
            更新中奖概率
          </Button>
        )}

        {!!onLotteryCodes && (
          <Button variant="outlined" size="small" startIcon={<RefreshIcon />} onClick={onLotteryCodes} sx={{ whiteSpace: "nowrap" }}>
            发放抽奖码
          </Button>
        )}

        {!!onRefresh && (
          <Button variant="outlined" size="small" startIcon={<RefreshIcon />} onClick={onRefresh} sx={{ whiteSpace: "nowrap" }}>
            刷新
          </Button>
        )}
      </Stack>

      {/* {numSelected > 0 ? (
        <Tooltip title="删除">
          <IconButton>
            <Icon icon={trash2Fill} />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="过滤列表">
          <IconButton>
            <Icon icon={roundFilterList} />
          </IconButton>
        </Tooltip>
      )} */}
    </RootStyle>
  );
}
